import * as jobActionTypes from './jobActionTypes';


export const clearNewJob = () => ({
  type: jobActionTypes.CLEAR_JOBS_DATA
});

export const updateJobsFilters = (updateObj) => ({
  type: jobActionTypes.JOBS_UPDATE_FILTERS,
  payload: updateObj
});